import { clsx } from 'clsx'
import React from 'react'
import { Pressable, View, type PressableProps, type ViewProps } from 'react-native'

import { useCardContext } from './card-context'

type TCardBodyProps = ViewProps & Pick<PressableProps, 'onPress'> & { ref?: React.Ref<View> }

export const CardFooter = ({ ref, className, children, ...otherProps }: TCardBodyProps) => {
  const { slots, classNames } = useCardContext()

  const Component = otherProps.onPress ? Pressable : View

  const footerStyles = clsx(classNames?.footer, className)

  return (
    <Component ref={ref} className={slots.footer?.({ class: footerStyles })} {...otherProps}>
      {children}
    </Component>
  )
}

CardFooter.displayName = 'CardFooter'
